export default __webpack_public_path__ + "static/media/letterType.778c3b69.mp3";